import React, { useState, useEffect } from 'react';

const HourSelect = () => {
    // 현재 시간에 해당하는 시 선택
    const getCurrentHour = () => {
        return new Date().getHours();
    };

    // 0-23시 자동 생성
    const getHours = () => {
        const hours = [];
        for (let hour = 0; hour < 24; hour++) {
            hours.push({ value: hour.toString(), label: hour.toString().padStart(2, '0') });
        }
        return hours;
    };

    const [selectedHour, setSelectedHour] = useState(getCurrentHour().toString());
    const hourOptions = getHours();

    useEffect(() => {
        setSelectedHour(getCurrentHour().toString());
    }, []);

    const handleChange = (event) => {
        setSelectedHour(event.target.value);
    };

    

    return (
        <select
            value={selectedHour}
            onChange={handleChange}
            style={{ width: '100%', padding: '0.5rem' }}
        >
            {hourOptions.map((hour) => (
                <option key={hour.value} value={hour.value}>{hour.label}</option>
            ))}
        </select>
    );
};

export default HourSelect;